import ButtonSystem from "@mui/material/Button";
import { circularProgressClasses } from "@mui/material/CircularProgress";
import { styled } from "../../styles/index.js";
import { generateUtilityClasses } from "@mui/material";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const buttonClasses = generateUtilityClasses("TrueButton", [
  "label",
  "sizeSmall",
  "endIcon",
  "startIcon"
]);
const ButtonRoot = styled(ButtonSystem, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueButton",
  slot: "Root"
})(({ theme, ownerState }) => {
  const button1 = theme.typography.button1 || theme.typography.body1;
  const button2 = theme.typography.button2 || theme.typography.body2;
  const button3 = theme.typography.button3 || theme.typography.body2;
  const tertiary = theme.palette.tertiary || theme.palette.secondary;
  return {
    ...button2,
    padding: theme.spacing(1.5, 2),
    lineHeight: theme.spacing(3),
    [`.${buttonClasses.startIcon}, .${buttonClasses.endIcon}`]: {
      alignItems: "center",
      fontSize: theme.spacing(3),
      "> svg": {
        fontSize: "inherit"
      }
    },
    [`.${buttonClasses.startIcon}`]: {
      marginRight: theme.spacing(1.5)
    },
    [`.${buttonClasses.endIcon}`]: {
      marginLeft: theme.spacing(1.5)
    },
    ["&:hover, &, &:active"]: {
      boxShadow: "none"
    },
    ...ownerState.color === "inherit" && {
      color: "inherit",
      background: "inherit",
      borderColor: "inherit",
      [":hover"]: {
        color: "inherit",
        background: "inherit",
        borderColor: "inherit"
      }
    },
    ...ownerState.color === "tertiary" && {
      color: theme.palette.text.high,
      [":hover"]: {
        background: tertiary.dark
      }
    },
    ...ownerState.color === "tertiary" && ownerState.variant === "contained" && {
      backgroundColor: tertiary.main
    },
    ...ownerState.color === "tertiary" && ownerState.variant === "outlined" && {
      borderColor: tertiary.main,
      background: "transparent",
      [":hover"]: {
        background: tertiary.dark,
        borderColor: tertiary.dark
      }
    },
    ...ownerState.size === "large" && {
      ...button1,
      padding: theme.spacing(2, 3)
    },
    ...ownerState.size === "small" && {
      ...button3,
      padding: theme.spacing(1.5, 2),
      [`.${buttonClasses.startIcon}, .${buttonClasses.endIcon}`]: {
        alignItems: "center",
        fontSize: theme.spacing(2)
      }
    },
    [`.${buttonClasses.label}`]: {
      lineHeight: theme.spacing(ownerState.size === "small" ? 2 : 3),
      display: "inline-flex",
      ...ownerState.loading && {
        opacity: 0
      }
    },
    [`.${circularProgressClasses.root}`]: {
      position: "absolute",
      width: `${theme.spacing(2)} !important`,
      height: `${theme.spacing(2)} !important`
    },
    [`&[class*="disabled"]`]: {
      background: theme.palette.action.disabled,
      borderColor: "transparent",
      color: theme.palette.text.low
    }
  };
});
export {
  ButtonRoot,
  buttonClasses
};
//# sourceMappingURL=button.styles.js.map
